import { VisitorChild } from "./visitorChild";

 export class Visitor {
    id: number;
    fullName: string;
    email: string;
    phone: string;
    address: string;
    city: string;
    roomId: number;
    birthDate: string;
    dateBirthFromQuery:string=''
    dateBirthToQuery:string=''
    registrationdate:string;
    registrationDateFromQuery:string;
    registrationDateToQuery:string;
    numberOfVisit: number;
    visitorStatus: number;
    comment: string;
    children: VisitorChild[];
    gratis:boolean;
    birtthYear:number;
    birthMonth:number;
   
    constructor() {
      this.fullName = '';
      this.email = '';
      this.phone = '';
      this.address = '';
      this.city ='';
      this.birthDate = '';
      this.dateBirthFromQuery=''
      this.dateBirthToQuery=''
      this.registrationdate=''
      this.registrationDateFromQuery='';
      this.registrationDateToQuery='';
      this.visitorStatus = null;
      this.comment = '';
      this.gratis=false;
      this.birtthYear=null;
      this.birthMonth=null;
      
    }
  }
